import {
  MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING,
  MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING_FOR_MIXPANEL,
} from './constants'

export type MemberPreferencesForUserV2 = {
  ethnicities: string[]
  gender: string[]
  isBipoc: boolean
  isLgbtqia: boolean
  religions: string[]
  isExperiencedWithVeterans: boolean
  preferredSessionFormat: string[] // coaching preference
  preferredAppointmentType: string[] // therapy preference
  availabilities?: string[] | null
  timeZone?: string
  customPreferencesText?: string
}

export type ProviderIdentity = {
  isBipoc: boolean
  isLgbtqia: boolean
}

export type ProviderSearchPreferencesV2 = {
  ethnicities: string
  gender: string
  isLgbtqia: boolean
  religions: string
  isExperiencedWithVeterans: boolean
  modalityPreference: string
  isBipoc: boolean
  visiblePreferences: string
  preferenceVariations: string | null
  customFreeTextPreference?: string | null
}

export type ProviderSearchPreferences = ProviderIdentity & {
  modalityPreference: string
}

// Based on Member preferences v1 schema
type UserPreferenceV1ValuesSimplified = {
  isBipoc?: boolean
  isLgbtqia?: boolean
  preferredSessionFormat?: string[]
  preferredAppointmentType?: string[]
}

// Based on Member preferences v2 schema
type UserPreferenceV2ValuesSimplified = {
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.ethnicities]?: string[]
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.gender]?: string[]
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.isLgbtqia]?: boolean
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.religions]?: string[]
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.isExperiencedWithVeterans]?: boolean
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.meetingSetting]?: string[]
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING.availabilities]?: string[] | null
}

// Same as UserPreferenceV2ValuesSimplified but can include conservative versions of gender and lgbtqia preferences
export type UserPreferenceV2ValuesSimplifiedForMixpanel = UserPreferenceV2ValuesSimplified & {
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING_FOR_MIXPANEL.genderConservative]?: string[]
  [MEMBER_PREFERENCES_CATEGORY_SIMPLIFIED_MAPPING_FOR_MIXPANEL.isLgbtqiaConservative]?: boolean
}

// Represents a simplified object (with only one prop representing meeting preference) that is passed to mixpanel and used to count number of user preferences
export type UserPreferenceValuesSimplified = UserPreferenceV1ValuesSimplified | UserPreferenceV2ValuesSimplified

// Determines which page the user is coming from to view member preferences page
export enum PreferencesEntrypointMapping {
  RECOMMENDATIONS_EXPLAINED = 'recommendations explained',
  PROVIDER_RESULTS = 'provider results',
  CONNECTED_CALENDAR = 'connected calendar',
}
